import { type FieldValues, type Path, type PathValue } from 'react-hook-form';

import { useFormElement } from '../useFormElement';

import { BaseGenericSelect, type BaseGenericSelectProps } from './BaseGenericSelect';

export type GenericSelectProps<S, T extends FieldValues, FP extends Path<T>> = Omit<
	BaseGenericSelectProps<S>,
	'error' | 'onChange' | 'ref' | 'value'
> & {
	defaultValue?: PathValue<T, FP>;
	name: FP;
};

export function GenericSelect<S, T extends FieldValues, FP extends Path<T> = Path<T>>({
	defaultValue,
	name,
	...props
}: GenericSelectProps<S, T, FP>) {
	const {
		field: { onChange, value },
		fieldState: { error }
	} = useFormElement<T, FP>({
		defaultValue,
		name
	});

	return <BaseGenericSelect error={error} value={value} onChange={onChange} {...props} />;
}
